import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Dialog = styled.div`
  width: 500px;
  background-color: ${ColorSF2.white};
  @media (max-height: 530px) {
    height: 310px;
    overflow-y: auto;
  }
`;

export const Tabs = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px 10px 0px 10px;
  @media (max-height: 530px) {
    font-size: 12px;
  }
`;
export const Tab = styled.div`
  flex: 1;
  height: 50px;
  padding: 12px;
  text-align: center;
  cursor: ${props => (props.current ? 'default' : 'pointer')};
  background-color: ${props =>
    props.current ? ColorSF2.paleBlue : ColorSF2.skyBlue};
  @media (max-height: 530px) {
    height: 30px;
    padding: 5px;
  }
`;
export const TabPadding = styled.div`
  padding: 5px;
`;
export const UpdateBody = styled.div`
  height: 320px;
  display: flex;
  flex-direction: column;
  padding: 15px;
`;
export const ClearBody = styled.div`
  height: 320px;
  display: flex;
  flex-direction: column;
  padding: 15px;
`;
export const Lists = styled.div`
  height: 40px;
  display: flex;
  flex-direction: row;
  background-color: ${ColorSF2.white};
  border-bottom: 1px solid ${ColorSF2.mediumGray};
`;
export const ListsTitle = styled.div`
  width: 200px;
  display: flex;
  background-color: ${ColorSF2.lightGray};
  align-items: center;
  padding-left: 10px;
`;
export const ListsItem = styled.div`
  width: calc(100% - 200px);
  display: flex;
  justify-content: center;
  padding: 8px;
`;
export const Input = styled.input`
  width: 100%;
`;
export const Info = styled.div`
  padding-bottom: 10px;
`;
export const WarningMessage = styled.div`
  margin: 7px 0 3px 0;
  color: ${ColorSF2.alertRed};
`;

export const ButtonArea = styled.div`
  padding-bottom: 15px;
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: center;
`;
export const UpdateButton = styled.div`
  width: 130px;
  height: 40px;
  border-radius: 5px;
  margin-left: 10px;
  background-color: ${props =>
    props.disabled ? ColorSF2.mediumGray : ColorSF2.navyBlue};
  opacity: ${props => (props.disabled ? '0.5' : '1')};
  ${props => props.disabled && 'pointer-events: none'};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => (props.disabled ? ColorSF2.black : ColorSF2.white)};
  cursor: pointer;
  font-size: 14px;
`;
export const CancelButton = styled.div`
  width: 130px;
  height: 40px;
  border-radius: 5px;
  margin-left: 10px;
  background-color: ${ColorSF2.white};
  border: 1px solid ${ColorSF2.mediumGray};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
`;
export const TagSelect = styled.select`
  width: 100%;
  color: #414141;
`;
export const CheckContents = styled.div`
  display: flex;
`;
export const CheckArea = styled.div`
  padding-left: 10px;
  width: 140px;
  height: 30px;
  display: flex;
  align-items: center;
`;
export const CheckboxWrapper = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const DefaultCheckbox = styled.input`
  display: none;
`;
export const CheckboxLabel = styled.label`
  width: 20px;
  height: 20px;
`;

export const AlertDeleteMessage = styled.p`
  color: ${ColorSF2.alertRed};
  margin-bottom: 5px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
